import { render, staticRenderFns } from "./RegistrationPanel.vue?vue&type=template&id=8996959c&"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports